import { adminApi } from './apiService';

// Utility function for uploads URL
export const getUploadsUrl = (filename) => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  return filename ? `${baseUrl}/uploads/${filename}` : null;
};

// Admin Authentication
export async function adminLogin({ email, password }) {
  const response = await adminApi.post(`/admins/login`, { email, password });
  return response.data;
}

export function adminLogout() {
  localStorage.removeItem('adminUserData');
  window.location.href = '/admin';
}

export async function getAdminList() {
  const response = await adminApi.get(`/admins/admin/list`);
  return response.data;
}

export async function createAdmin(adminData) {
  const response = await adminApi.post(`/admins/admin`, adminData);
  return response.data;
}

// User Management
export async function getUsersWithSubscription(page = 1, limit = 50) {
  const response = await adminApi.get(`/users/with-subscription?page=${page}&limit=${limit}`);
  return response.data;
}

export async function searchUsersWithSubscription(searchTerm, searchMode, page = 1, limit = 50) {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    search: searchTerm,
    searchMode: searchMode
  });
  const response = await adminApi.get(`/users/with-subscription?${params.toString()}`);
  return response.data;
}

export async function deleteUser(userId) {
  const response = await adminApi.delete(`/users/delete/${userId}`);
  return response.data;
}

export async function getUserProfile(userId) {
  const response = await adminApi.get(`/users/profile/${userId}`);
  return response.data;
}

// Order Management
export async function getAllOrders() {
  const response = await adminApi.get(`/orders`);
  return response.data;
}

export async function getOrderById(orderId) {
  const response = await adminApi.get(`/orders/${orderId}`);
  return response.data;
}

// Profile Management
/**
 * Get all profiles with pagination and search
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number (defaults to 1)
 * @param {string} params.search - Search query (optional)
 * @param {string} params.searchMode - Search mode: 'name', 'email', 'mobile', 'company', 'linkedin', 'all' (defa
ults to 'all')
 * @returns {Promise} Response with data, pagination, and search objects
 */
export async function getAllProfiles({ page = 1, search = '', searchMode = 'all' } = {}) {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  
  if (search) {
    params.append('search', search);
    params.append('searchMode', searchMode);
  }
  
  const response = await adminApi.get(`/profile/admin/all?${params.toString()}`);
  return response.data;
}

export async function getProfileById(profileId) {
  const response = await adminApi.get(`/profile/admin/${profileId}`);
  return response.data;
}

export async function updateProfile(profileId, profileData) {
  // MUST include /admin/ to match router.put('/admin/:id', admin, updateProfileById);
  const response = await adminApi.put(`/profile/admin/${profileId}`, profileData);
  return response.data;
}

export async function deleteProfile(profileId) {
  const response = await adminApi.delete(`/profile/${profileId}`);
  return response.data;
}

// Search Queries
export async function getUserSearchesWithUserInfo(userId) {
  const response = await adminApi.get(`/admins/searches/${userId}`);
  return response.data;
}

// Subscription Management
export async function getUserSubscription(userId) {
  const response = await adminApi.get(`/users/subscription/${userId}`);
  return response.data;
}

export async function updateUserSubscription(userId, subscriptionId, subscriptionData) {
  const response = await adminApi.put(`/users/subscription/${userId}`, {
    subscriptionId,
    ...subscriptionData
  });
  return response.data;
}